<template>
  <div class="col-sm-3 mb-5 mb-xl-10" >
    <div class="card card-flush h-lg-100">
      <div class="card-header pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bolder text-dark">{{$t('crm-setting.appointments')}}</span>
          <span class="text-gray-400 mt-1 fw-bold fs-6"></span>
        </h3>
      </div>
      <div class="card-body pt-5">
        <router-link :to="'crm-settings-appointments/appointment-type'" v-if="$can(abilities.VIEW_APPOINTMENT_TYPE)">
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('crm-setting.appointment.type')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
        <router-link :to="'crm-settings-appointments/appointment-rooms'" v-if="$can(abilities.VIEW_APPOINTMENT_TYPE)">
          <div class="card shadow-sm p-5 mb-2">
            <div class="d-flex flex-stack" >
              <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('crm-setting.appointment.rooms')}}</a>
              <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
              </button>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import abilities from "@/composables/abilities";
</script>

<style scoped>

</style>